window.addEventListener("load", function(){
  var carousels = document.querySelectorAll('.multi-collection');
  Array.from(carousels).forEach(function(element) {
     var flkty = new Flickity(element);
     flkty.resize();
  });  
}); 

function openCollection(evt, collectionName, boxName) {
  // Declare all variables
  var i, tabcontent, tablinks;
  
  var carouselClass = '.' + collectionName;
  
  var box = document.getElementById(boxName)
  
  var carousels = box.querySelectorAll('.multi-collection');
  
  // Get all elements with class="tabcontent" and hide them
  tabcontent = box.getElementsByClassName("tab-collection");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Get all elements with class="tablinks" and remove the class "active"
  tablinks = box.getElementsByClassName("multi-tab-link");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace("current", "");
  }

  // Show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(collectionName).style.display = "block";
  evt.currentTarget.className += " current";
  
  Array.from(carousels).forEach(function(element) {
    var flkty = new Flickity(element);
    flkty.resize();
    console.log(flkty);
  });
}

